const Block = {

    // FIELDS
    "block": "Block",
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Block",
    "filter_title": "Block Filter",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_description": "Description",
    
    // ERROR
    "error_name": "Enter Block Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

}

export default Block;

